import { z } from "zod";
import {
  DTOForgeChatMessageCreateInput,
  DTOForgeChatMessageCreateResponse,
  DTOForgeChatMessageListQuery,
  DTOForgeChatMessageListResponse,
  DTOForgeChatMessageScoreRequest,
  DTOForgeChatThreadCreateInput,
  DTOForgeChatThreadCreateResponse,
  DTOForgeChatThreadListQuery,
  DTOForgeChatThreadListResponse,
  DTOForgeChatThreadUpdateInput,
  DTOForgeChatThreadUpdateResponse,
} from "../../dto/forge/threads";
import { RequestExecutor } from "../../transport/request-executor";

export class WorkspaceChatThreadsEndpoint {
  readonly messages: ChatThreadMessagesEndpoint;

  constructor(private readonly requestExecutor: RequestExecutor) {
    this.messages = new ChatThreadMessagesEndpoint(requestExecutor);
  }

  create(workspaceId: string, body: DTOForgeChatThreadCreateInput) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/forge/threads`, DTOForgeChatThreadCreateResponse, {
      method: "POST",
      body,
    });
  }

  list(workspaceId: string, query?: DTOForgeChatThreadListQuery) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/forge/threads`, DTOForgeChatThreadListResponse, {
      query: query
        ? new URLSearchParams({
            ...(query.limit !== undefined && { limit: query.limit.toString() }),
            ...(query.offset !== undefined && { offset: query.offset.toString() }),
          })
        : undefined,
    });
  }

  update(workspaceId: string, threadId: string, body: DTOForgeChatThreadUpdateInput) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/threads/${threadId}`,
      DTOForgeChatThreadUpdateResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  delete(workspaceId: string, threadId: string) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/forge/threads/${threadId}`, z.any(), {
      method: "DELETE",
    });
  }
}

export class ChatThreadMessagesEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string, threadId: string, query?: DTOForgeChatMessageListQuery) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/threads/${threadId}/messages`,
      DTOForgeChatMessageListResponse,
      {
        query: query
          ? new URLSearchParams({
              ...(query.limit !== undefined && { limit: query.limit.toString() }),
              ...(query.offset !== undefined && { offset: query.offset.toString() }),
            })
          : undefined,
      }
    );
  }

  create(workspaceId: string, threadId: string, body: DTOForgeChatMessageCreateInput) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/threads/${threadId}/messages`,
      DTOForgeChatMessageCreateResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  score(workspaceId: string, threadId: string, body: DTOForgeChatMessageScoreRequest) {
    return this.requestExecutor.json(`/workspaces/${workspaceId}/forge/threads/${threadId}/scores`, z.any(), {
      method: "POST",
      body,
    });
  }
}
